import { Component, Input } from '@angular/core';
import { ComponentData } from '../../../models/component-data.model';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-form-render-component',
    imports: [CommonModule],
    templateUrl: './form-render.component.html'
})
export class FormRenderComponent {
  @Input() formComponents: ComponentData[] = [];
}
